import DialogPopup from '../components/dialogs/DialogPopup';//eslint-disable-line import/no-named-as-default
import ContentDialog from '../components/dialogs/ContentDialog';//eslint-disable-line import/no-named-as-default
import InitDialog from  '../components/dialogs/InitDialog';//eslint-disable-line import/no-named-as-default
//import ClickRevealDialog from '../components/dialog/ClickRevealDialog';//eslint-disable-line import/no-named-as-default
import AssetDialog from '../components/dialogs/AssetDialog';//eslint-disable-line import/no-named-as-default
import ScreenDialog from '../components/dialogs/screenDialog/ScreenDialog';//eslint-disable-line import/no-named-as-default

export const DIALOG_POPUP = DialogPopup;
export const CONTENT_DIALOG = ContentDialog;
export const INIT_DIALOG = InitDialog;
export const ASSET_DIALOG = AssetDialog;
export const SCREEN_DIALOG = ScreenDialog;
//export const CLICK_REVEAL_DIALOG_POPUP = ClickRevealDialog;

export const DIALOG_COMPONENTS = {
    DIALOG_POPUP: DIALOG_POPUP,
    CONTENT_DIALOG: CONTENT_DIALOG,
    INIT_DIALOG: INIT_DIALOG,
    ASSET_DIALOG: ASSET_DIALOG,
    SCREEN_DIALOG: SCREEN_DIALOG
    //CLICK_REVEAL_DIALOG_POPUP: CLICK_REVEAL_DIALOG_POPUP
};

export const DIALOG = 'DIALOG';
//export const CLICK_REVEAL_DIALOG = 'CLICK_REVEAL_DIALOG';
export const DIALOG_CLASSNAME = 'content-dialog';
export const AUTH_DIALOG_CLASSNAME = 'auth-dialog';
export const ASSET_DIALOG_CLASSNAME = 'asset-content-dialog';
export const SCREEN_DIALOG_CLASSNAME = 'screen-dialog';
export const SIDE_DIALOG_CLASSNAME = 'side-dialog';
//export const CLICK_REVEAL_DIALOG_CLASSNAME = 'click-reveal-dialog';


export const DIALOG_CLASS_STATE_OPEN = 'dialog-open';
export const DIALOG_CLASS_STATE_CLOSED = 'dialog-closed';

export const LAYOUT_TYPE_LARGE_DIALOG = "large_dialog";
export const LAYOUT_TYPE_SMALL_DIALOG = "small_dialog";
export const LAYOUT_TYPE_LEFT_SMALL_FLYOUT = "left_small_flyout";
export const LAYOUT_TYPE_LEFT_LARGE_FLYOUT = "left_large_flyout";
export const LAYOUT_TYPE_RIGHT_SMALL_FLYOUT = "right_small_flyout";
export const LAYOUT_TYPE_RIGHT_LARGE_FLYOUT = "right_large_flyout";



export const DIALOG_LAYOUT_TYPES = [
    LAYOUT_TYPE_LARGE_DIALOG,
    LAYOUT_TYPE_SMALL_DIALOG,
    LAYOUT_TYPE_LEFT_SMALL_FLYOUT,
    LAYOUT_TYPE_LEFT_LARGE_FLYOUT,
    LAYOUT_TYPE_RIGHT_SMALL_FLYOUT,
    LAYOUT_TYPE_RIGHT_LARGE_FLYOUT
];




/** WEBPACK FOOTER **
 ** ./src/constants/dialogConstants.js
 **/